import module from 'finanzas/module.js'
import template from './template.html'

class FinanzasClasificarmovimientosMasivoListaItemComponent {
  constructor () {
    this.data = null
    this.onDelete = null
    this.onChange = null
  }

  actualizar () {
    this.onChange({$event: {data: this.data}});
  }
}

module.component('finanzasClasificarmovimientosMasivoListaItem', {
  controller: FinanzasClasificarmovimientosMasivoListaItemComponent,
  template,
  bindings: {
    data: '<',
    onDelete: '&',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/_/clasificarmovimientos/components/masivo/lista/item/component.js